import { useDocumentTitle, useScrollTop, useModal } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter, Redirect } from 'react-router-dom';
import { getPlans } from 'redux/actions/homeActions';
import { useDispatch, useSelector } from 'react-redux';
import { ACCOUNT } from 'constants/routes';
import firebase from '../../../firebase/firebase';
import PaypalModal from './PaypalModal';

const Pricing = () => {
  const { t } = useTranslation();
  useDocumentTitle('Pricing - Uilpi');
  useScrollTop();
  const [selectedPlan, setSelectedPlan] = useState({});

  const store = useSelector((state) => ({
    user: state.auth,
    profile: state.profile
  }));

  const modal = useModal();

  const openModal = () => {
    modal.onOpenModal();
  };

  const selectPlan = (plan) => {
    setSelectedPlan(plan);
    openModal();
  };

  if (store.profile?.role !== 'COMPANY') {
    return <Redirect to={ACCOUNT} />;
  }

  const dispatch = useDispatch();
  const plansSelector = useSelector((state) => state.home.plans);
  useEffect(() => {
    if (plansSelector.length === 0) dispatch(getPlans());
  }, []);

  return (
    <div className="pricing-section">
      <br />
      <h1>Pricing</h1>
      <div className="pricing-container">
        <div className="pricing-row">
          {plansSelector?.map((plan, index) => {
            return (
              <div key={plan.id} className="pricing-col-md-4 pricing-col-sm-6">
                <div
                  className={`pricingTable ${
                    // eslint-disable-next-line no-nested-ternary
                    index === 0 ? '' : index === 1 ? 'silver' : 'gold'
                  }`}
                >
                  <div className="pricingTable-header">
                    <h3 className="title">{plan.name}</h3>
                    <span className="price-value">
                      {firebase.clientLocation === 'Italia'
                        ? plan.priceEur
                        : plan.priceChf}{' '}
                      {firebase.clientCurrency}
                    </span>
                  </div>
                  <ul className="pricing-content">
                    <li>
                      {plan.months} {t('pricingMonths')}
                    </li>
                    <li>
                      {plan.limitProducts} {t('pricingProducts')}
                    </li>
                    <li>
                      {plan.limitPhotos} {t('pricingPhotos')}
                    </li>
                  </ul>
                  <button
                    type="button"
                    onClick={() => selectPlan(plan)}
                    className="pricingTable-choose"
                  >
                    {t('buttonSelect')}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <PaypalModal
        modal={modal}
        selectedPlan={selectedPlan}
        userId={store.user.id}
      />
    </div>
  );
};

export default withRouter(Pricing);
